var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeCancellationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.61865 11.0662L9.31403 12.7616L12.4998 9.44043",
    stroke: "#008F4B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8351 2.5L6.70905 4.62605L8.8351 6.7521L9.54126 6.04594L8.62203 5.125L10.0204 5.12538C13.1639 5.12538 15.7084 7.66983 15.7084 10.8134C15.7084 13.9569 13.1639 16.5013 10.0204 16.5013C6.94235 16.5013 4.43869 14.0618 4.3357 11.009L4.33241 10.8134H3.33375C3.33375 14.5084 6.32532 17.5 10.0204 17.5C13.7155 17.5 16.707 14.5084 16.707 10.8134C16.707 7.18801 13.8273 4.23986 10.2288 4.1299L10.0204 4.12672L8.62036 4.12667L9.54126 3.20615L8.8351 2.5Z",
    fill: "#008F4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeCancellationIcon);
export default __webpack_public_path__ + "static/media/free-cancellation-icon.f4574d27f0ada164ba66b905f3ae742b.svg";
export { ForwardRef as ReactComponent };